import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoadingRedux: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { 
    setLoadingRedux,
} = commonSlice.actions;
export default commonSlice.reducer;